<template>
  <md-dialog
    :md-active.sync="data.show"
    :md-click-outside-to-close="false"
    :md-close-on-esc="false"
  >
    <md-dialog-title>{{ data.title }}</md-dialog-title>
    <md-dialog-content>
      <span>
      {{ data.message }}
      <md-progress-bar md-mode="indeterminate"></md-progress-bar>
      </span>
    </md-dialog-content>
  </md-dialog>
</template>
<script>
  export default {
    props: {
        data: {
            type: Object,
            required: true
        }
      },
  }
</script>
